const enquiries = {
  enquiries: {
    title: 'Enquiries',
    subtitle: 'Manage conversations with potential clients',
    noThreads: 'No enquiries yet',
    noThreadsDescription: 'When someone enquires about your properties, conversations will appear here.',
    searchPlaceholder: 'Search conversations...',

    threadList: {
      title: 'Conversations',
      empty: 'No conversations',
      unread: '{{count}} unread',
      lastMessage: 'Last message',
    },

    chat: {
      placeholder: 'Type your message...',
      send: 'Send',
      sending: 'Sending...',
      messageSent: 'Message sent',
      messageError: 'Failed to send message',
      loadingMessages: 'Loading messages...',
      noMessages: 'No messages yet',
      startConversation: 'Start the conversation',
      you: 'You',
      today: 'Today',
      yesterday: 'Yesterday',
    },

    property: {
      viewProperty: 'View property',
      price: 'Price',
    },

    notifications: {
      newMessage: 'New message',
      newEnquiry: 'New enquiry',
      title: 'Notifications',
    },

    accessDenied: {
      title: 'Access Denied',
      description: 'You need an active subscription to access enquiries.',
      subscribeButton: 'View Subscription Plans',
    },

    loginRequired: {
      title: 'Login Required',
      description: 'Please sign in to view your enquiries.',
      loginButton: 'Sign In',
    },
  },
};

export default enquiries;
